const tables = {
    nameFiller: '[NO NAME]',
    saveTable: '[EN] ZAPISZ',
};

export default tables;